// src/components/ProblemSpark.jsx
import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Avatar,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";

import SaraImage from "../assets/sara-1.jpeg";

export default function ProblemSpark() {
  const bullets = [
    {
      title: "You’re emotionally drained and questioning if you’re enough.",
      desc:
        "You pour everything into your kids, yet end most days wondering if you were patient enough, calm enough, good enough.",
    },
    {
      title: "Your child’s big emotions feel too big to handle.",
      desc:
        "Tantrums, tears, or sudden silence — you’re never sure what to do next. Without the right emotional language, kids learn to bottle up instead of open up and that affects their confidence for years to come.",
    },
    {
      title: "Family time feels rushed, chaotic, or disconnected.",
      desc:
        "Between rushed mornings and screen-filled evenings, those little laughter-filled moments you crave feel harder and harder to hold onto.",
    },
    {
      title: "You’re drowning in parenting advice that doesn’t fit your life.",
      desc:
        "You’ve read the blogs, listened to podcasts and yet, nothing feels real or sustainable. What you actually need is a simple, science-backed path that meets your family where you are.",
    },
    {
      title: "You want to raise kind, confident, grateful kids, but don’t know how.",
      desc:
        "Because love alone isn’t always enough. Kids need tools, rituals, and language that teach them how to express emotions, build resilience, and grow with hope.",
    },
  ];

return (
    <Box component="section" sx={{ py: { xs: 4, md: 8 }, bgcolor: "transparent" }}>
        <Box sx={{width: '100%'}}>
            <Grid
                item
                xs={12}
                md={8}
                sx={{
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Typography
                    component="h2"
                    sx={{
                        fontSize: { xs: "1.6rem", md: "32px" },
                        fontWeight: 400,
                        color: "rgba(28,30,46,1)",
                        maxWidth: 800,
                    }}
                >
                    <strong>Do you love your kids more than anything… but still feel like you’re not enough?</strong>
                </Typography>

                <Typography
                    sx={{
                        fontSize: { xs: "1rem", md: "20px" },
                        color: "rgba(74,74,74,1)",
                        mt: 1.25,
                        maxWidth: 700,
                    }}
                >
                    Every parent has felt these quiet struggles, BUT rarely says them out loud.
                </Typography>
            </Grid>

            {/* IMAGE AND BULLETS SIDE BY SIDE */}
            <Grid
                container
                spacing={4}
                alignItems="flex-start"
                justifyContent="center"
                sx={{ mt: { xs: 4, md: 6 } }}
            >
                {/* LEFT IMAGE */}
                <Grid item xs={12} md={5} sx={{ display: "flex", justifyContent: "center" }}>
                    <Avatar
                        src={SaraImage}
                        alt="Book Cover"
                        variant="square"
                        sx={{
                            width: { xs: 250, sm: 320, md: 400 },
                            height: "auto",
                            borderRadius: 2,
                            boxShadow: "0 10px 30px rgba(15,23,32,0.08)",
                        }}
                    />
                </Grid>

                {/* BULLETS */}
                <Grid item xs={12} md={7}>
                    <List>
                        {bullets.map((b, idx) => (
                            <ListItem
                                key={idx}
                                disableGutters
                                alignItems="flex-start"
                                sx={{ py: { xs: 1.5, md: 1 } }}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: "auto",
                                        mr: 1,
                                        mt: 1.5,
                                        alignItems: "center",
                                    }}
                                >
                                    <StarIcon sx={{ fontSize: 18 }} />
                                </ListItemIcon>

                                <ListItemText
                                    primary={
                                        <Typography
                                            sx={{
                                                fontSize: { xs: "16px", md: "19px" },
                                                color: "rgba(0,0,0,1)",
                                                fontWeight: 700,
                                                display: "inline-flex",
                                                alignItems: "baseline",
                                                gap: "6px",
                                            }}
                                        >
                                            <u>{b.title}</u>
                                        </Typography>
                                    }
                                    secondary={
                                        <Typography
                                            sx={{
                                                fontSize: { xs: "14.5px", md: "16px" },
                                                color: "rgba(0,0,0,0.9)",
                                                mt: 0.6,
                                            }}
                                        >
                                            {b.desc}
                                        </Typography>
                                    }
                                    sx={{ ml: 0.5 }}
                                />
                            </ListItem>
                        ))}
                    </List>
                </Grid>
            </Grid>
        </Box>
    </Box>
);
}
